import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Layouts
import Layout from './pages/Layout';
import AdminLayout from './AdminPages/AdminLayout';
import AdminProtectedRoute from './AdminPages/AdminProtectedRoute';

// Public Pages
import Home from './pages/home/Home';
import Gallery from './pages/gallery/Gallery';
import Contact from './pages/contact/Contact';
import News from './pages/News/News';
import ViewDonor from './pages/ViewDonor/ViewDonor'

// Admin Pages
import AdminSignIn from './AdminPages/AdminSignIn/AdminSignIn';
import ViewContact from './AdminPages/contact/ViewContact';
import AddSlider from './AdminPages/home/AddSlider/AddSlider';
import AddGallery from './AdminPages/AddGallery/AddGallery';
import AddNews from './AdminPages/News/AddNews';
import PageNotFound from './pages/PageNotFound/PageNotFound';
import ChangePassword from './AdminPages/ChangePassword/ChangePassword';
import AboutMission from './pages/about/AboutMission/AboutMission';
import AboutConstitution from './pages/about/AboutConstitution/AboutConstitution';
import AboutMember from './pages/about/AboutMember/AboutMember';
import IdealHistory from './pages/History/IdealHistory/IdealHistory';
import PratibhaKhojPariksha from './pages/PratibhaKhoj/PratibhaKhojPariksha/PratibhaKhojPariksha';
import ScholarshipProcedure from './pages/PratibhaKhoj/ScholarshipProcedure/ScholarshipProcedure';
import ScholarsList from './pages/PratibhaKhoj/ScholarsList/ScholarsList';
import NewsDetail from './pages/News/NewsDetail/NewsDetail';
import AddDonor from './AdminPages/AddDonor/AddDonor';
import AddDonation from './AdminPages/AddDonation/AddDonation';
import DonateNow from './pages/DonateNow/DonateNow';
import AddExpense from './AdminPages/AddExpense/AddExpense';
import Expense from './pages/Expense/Expense';
import AddEvent from './AdminPages/AddEvent/AddEvent';
import Event from './pages/Event/Event';
import EventDetail from './pages/Event/EventDetail/EventDetail';
import DonationReceipt from './AdminPages/DonationReceipt/DonationReceipt';
import ReminderEncouragementFund from './AdminPages/ReminderEncouragementFund/ReminderEncouragementFund';
import AddScholarship from './AdminPages/Scholar/AddScholarship/AddScholarship';
import AddScholar from './AdminPages/Scholar/AddScholar/AddScholar';
import ReminderScholarList from './AdminPages/Scholar/ReminderScholarList/ReminderScholarList';
import History from './pages/History/History/History';
import Privacy from './pages/Privacy/Privacy';
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions';
import Refund from './pages/Refund/Refund';
import PaymentSuccess from './pages/PaymentSuccess/PaymentSuccess';
import PratibhaKhojForm from './AdminPages/PratibhaKhojForm/PratibhaKhojForm';
import NidhiDonation from './AdminPages/AddDonation/NidhiDonation/NidhiDonation';
import DonateNidhi from './pages/DonateNidhi/DonateNidhi';
import ViewDonorNidhi from './pages/ViewDonorNidhi/ViewDonorNidhi';
import AnnualReport from './pages/AnnualReport/AnnualReport';
import AddAnnualReport from './AdminPages/AddAnnualReport/AddAnnualReport';
import LifetimeMember from './AdminPages/LifetimeMember/LifetimeMember';
import PaymentFailed from './pages/PaymentFailed/PaymentFailed';
import AddNidhiDonation from './AdminPages/AddNidhiDonation/AddNidhiDonation';
import AddNormaldonation from './AdminPages/AddNormalDonation/AddNormalDonation';
import AddDonorPaymentStatus from './AdminPages/AddDonorPaymentStatus/AddDonorPaymentStatus';
import OnlineReceipt from './AdminPages/OnlineReceipt/OnlineReceipt';

function App() {
  return (
    <Router>
      <Routes>

        {/* ================= PUBLIC ROUTES ================= */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about/mission-vision" element={<AboutMission />} />
          <Route path="/about/constitution" element={<AboutConstitution />} />
          <Route path="/about/members" element={<AboutMember />} />
          <Route path="/about/annual-report" element={<AnnualReport />} />
          <Route path="/history/rajput-shiksha-kosh" element={<History />} /> 
          <Route path="/history/ideal-history" element={<IdealHistory />} /> 
          <Route path="/pratibha-khoj/pariksha" element={<PratibhaKhojPariksha />} /> 
          <Route path="/pratibha-khoj/scholarship-procedure" element={<ScholarshipProcedure />} /> 
          <Route path="/pratibha-khoj/scholars-list" element={<ScholarsList />} /> 
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:slug" element={<NewsDetail />} />
            <Route path="/donor" element={<ViewDonor />} />
            <Route path="/protsahan-nidhi" element={<ViewDonorNidhi />} />
            <Route path="/donate-now" element={<DonateNow />} />
            <Route path="/donate-protsahan-nidhi" element={<DonateNidhi/>} />
          <Route path="/expenses" element={<Expense />} />
          <Route path="/events" element={<Event />} />
          <Route path="/events/:slug" element={<EventDetail />} />
           <Route path="*" element={<PageNotFound />} />
           <Route path="/privacy-policy" element={<Privacy />} />
           <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
           <Route path="/refund" element={<Refund />} />

           <Route path="/payment-success/:txnNo" element={<PaymentSuccess />} />
           <Route path="/payment-failed" element={<PaymentFailed />} />
        </Route>

        {/* ================= ADMIN LOGIN ================= */}
        <Route path="/admin" element={<AdminSignIn />} />

        {/* ================= PROTECTED ADMIN ROUTES ================= */}
        <Route
  element={
    <AdminProtectedRoute>
      <AdminLayout />
    </AdminProtectedRoute>
  }
>
  <Route path="/admin/view-contact" element={<ViewContact />} />
  <Route path="/admin/add-slider" element={<AddSlider />} />
  <Route path="/admin/add-gallery" element={<AddGallery />} />
  <Route path="/admin/add-annual-report" element={<AddAnnualReport />} />
  <Route path="/admin/add-news" element={<AddNews />} />
  <Route path="/admin/change-password" element={<ChangePassword />} />
  <Route path="/admin/add-donors" element={<AddDonor />} />
  {/* <Route path="/admin/add-donations" element={<AddDonation />} /> */}
  <Route path="/admin/add-donations" element={<AddNormaldonation />} />
  {/* <Route path="/admin/nidhi-donations" element={<NidhiDonation />} /> */}
  <Route path="/admin/nidhi-donations" element={<AddNidhiDonation />} />
  <Route path="/admin/donor-payment-status" element={<AddDonorPaymentStatus />} />
  <Route path="/admin/donor-online-receipt" element={<OnlineReceipt />} />
  <Route path="/admin/donation-receipt" element={<DonationReceipt />} />
  <Route path="/admin/lifetime-member" element={<LifetimeMember />} />
  <Route path="/admin/add-scholars" element={<AddScholar />} />
  <Route path="/admin/add-scholarship" element={<AddScholarship />} />
  <Route path="/admin/reminder-scholars" element={<ReminderScholarList />} />
  <Route path="/admin/add-expenses" element={<AddExpense />} />
  <Route path="/admin/add-events" element={<AddEvent />} />
  <Route path="/admin/reminder-encouragement-fund" element={<ReminderEncouragementFund />} />
  <Route path="/admin/pratibha-khoj-form" element={<PratibhaKhojForm />} />
</Route>

      </Routes>
    </Router>
  );
}

export default App;
